module.exports = "/_next/static/chromiums/apple-touch-startup-828x1792-image-d4cf6cb2dc3d41a0a67b31b40bedf87f.png";